import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption } from 'gung-list';
import { GungFlowService, Product, ProductSortService } from 'gung-standard';
import { BehaviorSubject, map, Observable, of, Subject, switchMap } from 'rxjs';
import { OttoOlsenProductService } from './otto-olsen-product.service';
import { OttoOlsenProductCrossReferenceListViewComponent } from '../components/otto-olsen-product-cross-reference-list-view/otto-olsen-product-cross-reference-list-view.component';

@Injectable({
  providedIn: 'root'
})
export class OttoOlsenFilterSearchCrossReferenceListConfigService implements ConfigService<Product> {
  search: Subject<string> = new BehaviorSubject(null);
  flowId: string;
  customerId: string;

  topFilter = false;
  searchDisabled = true;
  keepFilterOpen = false;

  constructor(
    protected productService: OttoOlsenProductService,
    protected productSortService: ProductSortService,
    protected gungFlowService: GungFlowService,
  ) {}

  getFilters(): ConfigBaseFilter<Product>[] {
    return [];
  }

  getSortOptions(): ListSortOption<Product>[] {
    // TODO: implement
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => OttoOlsenProductCrossReferenceListViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      }
    ];
  }

  getItems(): Observable<Product[]> {
    return this.search.pipe(
      switchMap(search => this.fetchProducts(this.filterSearchTerm(search), this.flowId, this.customerId))
    );
  }

  protected filterSearchTerm(search: string): string {
    let filteredSearch = search || '';
    filteredSearch = search.replaceAll(/[^0-9a-z]/gi, '');
    return filteredSearch;
  }

  protected fetchProducts(searchTerm: string, flowId: string, customerId: string): Observable<Product[]> {
    return this.productService.getProductsFilterSearchCrossReference(searchTerm, flowId, customerId).pipe(
      map(products => this.productSortService.sortProducts(products))
    );
  }

  getItemId(item: Product) {
    return item.id;
  }

  getSearchTerms(item: Product) {
    return [item.id, item.name];
  }

  getCurrentFlow(): Observable<any> {
    return this.gungFlowService.getGungFlow(this.flowId);
  }

  getSearchGroupCss(): string {
    return 'd-none';
  }
}
